"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "29.001" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "6.003" : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? "#FFFFFF" : _ref$fill,
      other = _objectWithoutPropertiesLoose(_ref, ["width", "height", "fill"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height,
    fill: "none",
    viewBox: "0 0 29.001 6.003"
  }, other), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.387 5.96 12.56-3.165a1.394 1.394 0 0 0 1-1.735 1.407 1.407 0 0 0-1.695-.978l-12.56 3.166a1.416 1.416 0 0 0-.144.044 1.407 1.407 0 0 0-.24-.084L1.75.043a1.407 1.407 0 0 0-1.695.978 1.394 1.394 0 0 0 1 1.734l12.56 3.166c.288.072.58.05.84-.049a1.4 1.4 0 0 0 .933.088Z",
    fillRule: "evenodd",
    fill: fill
  }));
};

var _default = _react["default"].memo(Icon);

exports["default"] = _default;
module.exports = exports.default;